export function parseCsv(content) {
    const rows = [];
    const lines = content.split(/\r?\n/);
    for (const line of lines) {
        if (line.trim() === '') {
            continue;
        }
        rows.push(parseCsvLine(line));
    }
    return rows;
}
function parseCsvLine(line) {
    const fields = [];
    let current = '';
    let inQuotes = false;
    for (let i = 0; i < line.length; i++) {
        const char = line[i];
        if (inQuotes) {
            if (char === '"') {
                if (i + 1 < line.length && line[i + 1] === '"') {
                    current += '"';
                    i++;
                }
                else {
                    inQuotes = false;
                }
            }
            else {
                current += char;
            }
        }
        else {
            if (char === '"') {
                inQuotes = true;
            }
            else if (char === ';') {
                fields.push(current.trim());
                current = '';
            }
            else {
                current += char;
            }
        }
    }
    fields.push(current.trim());
    return fields;
}
export function readFileAsText(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = () => reject(reader.error);
        reader.readAsText(file, 'UTF-8');
    });
}
